import { debounce } from "throttle-debounce";
import { getStorage, setStorage } from "../globals/storage";

const Contact = (target) => {
  const el = {
    buttons: target.querySelector(".contact__buttons"),
    close: target.querySelector(".contact__close"),
    trigger: target.querySelector(".contact__trigger"),
  };

  let hovered = false;
  let minimized = !!getStorage("session", "vrFirstLoad");

  const method = {
    init: () => {
      if (getStorage("session", "vrFirstLoad")) {
        target.classList.add("contact--active");
        target.classList.add("contact--static");

        el.buttons.setAttribute("aria-hidden", "false");
        el.close.setAttribute("aria-hidden", "false");
        el.trigger.setAttribute("aria-hidden", "true");
        setTimeout(() => {
          target.classList.remove("contact--static");
        }, 100);
      }

      el.close.addEventListener("click", method.minimizeContact);
      el.trigger.addEventListener("click", method.maximizeContact);

      target.addEventListener("mouseenter", () => {
        hovered = true;
      });
      target.addEventListener("mouseleave", () => {
        hovered = false;
      });

      if (minimized) {
        method.revealContact(minimized);
      } else {
        window.addEventListener("load", () => {
            method.revealContact(false);
        });
      }

      setStorage("session", "vrFirstLoad", true);
    },

    maximizeContact: () => {
      target.classList.add("contact--transitioning");
      target.classList.remove("contact--minimized");
      el.buttons.setAttribute("aria-hidden", "false");
      el.close.setAttribute("aria-hidden", "false");
      el.trigger.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        minimized = false;
        target.classList.remove("contact--transitioning");
      }, 500);
    },

    minimizeContact: () => {
      target.classList.add("contact--transitioning");
      target.classList.add("contact--minimized");
      el.buttons.setAttribute("aria-hidden", "true");
      el.close.setAttribute("aria-hidden", "true");
      el.trigger.setAttribute("aria-hidden", "false");
      setTimeout(() => {
        minimized = true;
        target.classList.remove("contact--transitioning");
      }, 500);
    },

    revealContact: (minimized = false) => {
      if ((window.matchMedia('screen and (max-width: 775px)').matches))
      {
        minimized = true;
      }

      if (minimized) {
        // console.log("Show just minimized");
        target.classList.add("contact--minimized");
        target.classList.add("contact--active");
        el.buttons.setAttribute("aria-hidden", "true");
        el.close.setAttribute("aria-hidden", "true");
        el.trigger.setAttribute("aria-hidden", "false");
        minimized = true;
      } else {
        setTimeout(() => {
          target.classList.add("contact--active");
          target.setAttribute("aria-hidden", "false");
          el.buttons.setAttribute("aria-hidden", "false");
          el.close.setAttribute("aria-hidden", "false");
          setTimeout(() => {
            if (!hovered) method.minimizeContact();
          }, 2500);
        }, 1000);
      }
    },
  };

  method.init();
};

export default Contact;
